import React from 'react';
import PropTypes from 'prop-types';

class DelayedAppear extends React.Component {
    static propTypes = {
        delay: PropTypes.number,
        loaderDelay: PropTypes.number,
        loader: PropTypes.any
    };

    constructor(props) {
        super(props);
        this.state = {
            delaying: props.delay,
            loaderDelaying: props.loaderDelay || 0
        };
        this.appear = this.appear.bind(this);
        this.loaderAppear = this.loaderAppear.bind(this);
    }

    appear() {
        this.setState({
            delaying: false
        });
    }
    loaderAppear() {
        this.setState({
            loaderDelaying: false
        });
    }

    UNSAFE_componentWillMount() {
        if (this.props.delay) {
            this._timer = setTimeout(this.appear, this.props.delay);
            if (this.props.loaderDelay) {
                this._loaderTimer = setTimeout(this.loaderAppear, this.props.loaderDelay);
            }
        }
    }
    componentWillUnmount() {
        if (this._timer) {
            clearTimeout(this._timer);
        }
        if (this._loaderTimer) {
            clearTimeout(this._loaderTimer);
        }
    }

    render() {
        if (this.state.delaying) {
            const Loader = this.props.loader;
            return Loader ? <Loader loaderDelaying={this.state.loaderDelaying} /> : null;
        }
        return this.props.children;
    }
}

export default DelayedAppear;
